import React from "react"

import editGracePeriod from './images/edit_grace_period.png'
import edQuotaJulian from './images/edquota_julian.png'
import quotaFiles from './images/quota_files.png'
import repQuota from './images/repquota.png'

import styles from './DiskQuota.module.scss'
import globalStyles from "../../../../App.module.scss";

export default function DiskQuota() {
    return (
        <div className={styles.diskQuota}>
            <h1>Manage user/group quota</h1>
            <div>
                <p>To manage user quota it is necessary to install the 'quota' package. It is not installed by
                    default.</p>

                <pre className={globalStyles.code}>root@sh-srv:~# apt-get install quota</pre>

                <p>Create quota files using the 'quotacheck' command followed by the options and the
                    device or path where it is mounted. In the example the device name is used.</p>

                <pre className={globalStyles.code}>root@sh-srv:~# quotacheck -cug /dev/sda1</pre>

                <p>-c<i> Create file </i></p>

                <p>-u <i>User file</i></p>

                <p>-g <i>Group file</i></p>
                <div className={styles.image} style={{maxWidth: '486px', maxHeight: '135px'}}>
                    <img src={quotaFiles} alt="quota_files"/>
                </div>

                <p>The new files 'aquota.group' amdaquota.user' are binary files and therefore can not be
                    edited with a text editor. To edit these files it is necessary to use the
                    'edquota' tool follow by the user/group.</p>

                <pre className={globalStyles.code}>root@sh-srv:~# edquota -u julian</pre>

                <p>The 'edquota' tool will parse a piece of the 'aquota.user' file so it will be
                    editable. It is possible to limit the amount of blocks and inodes the user can
                    use in the partition.</p>

                <div className={styles.image} style={{maxWidth: '841px', maxHeight: '150px'}}>
                    <img src={edQuotaJulian} alt="edquota_julian"/>
                </div>

                <p><b>Soft Limit</b> - Number of blocks/inodes that can be used by the user</p>

                <p><b>Hard Limit</b> - When the soft limit is passed the user can still save data until it reaches the
                    hard limit
                    within the grace period.</p>

                <p><b>Grace period</b> - Default is 7 days in which the user after passing the soft limit can
                    still store files.</p>

                <p>Once the soft limit is passed the user has a period of time to
                    get under the soft limit wich is called the <i>grace period</i>. During
                    the grace time the user can still save data until the hard limit is reached.
                    Either reaching the hard limit or expiring the grace time will cause the user
                    not to be able to save more files.</p>

                <p>To activate quotas:</p>

                <pre className={globalStyles.code}>root@sh-srv:~# quotaon</pre>

                <p>To deactivate quotas:</p>

                <pre className={globalStyles.code}>root@sh-srv:~# quotaoff</pre>

                <p>To change the grace period:</p>

                <pre className={globalStyles.code}>root@sh-srv:~# edquota -t</pre>
                <div className={styles.image} style={{maxWidth: '655px', maxHeight: '134px'}}>
                    <img src={editGracePeriod} alt={""}/>
                </div>
                <p>The 'repquota' tool will provide an overview of the disk quota usage.</p>

                <pre className={globalStyles.code}>root@sh-srv:~# repquota /dev/sda1</pre>

                <div className={styles.image} style={{maxWidth: '672px', maxHeight: '164px'}}>
                    <img src={repQuota} alt={""}/>
                </div>
            </div>
        </div>
    )
}